import get from 'lodash/get';

import {
  ADD_ABORT_CONTROLLER,
  ASYNC_END,
  ASYNC_START,
  CLEAR_ABORT_CONTROLLER,
  COUNTRIES_LOADED,
  GET_DELIVERY_TYPES_SUCCESS,
  GET_SERVICE_DATA_SUCCESS,
  GET_STATES_BY_COUNTRY_ID_SUCCESS,
  GET_TIMEZONES_DATA_SUCCESS,
  GET_USER_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  PIN_BUILDING,
  PMC_LIST_REQUESTED,
  SERVICE_REQUEST_CATEGORIES_REQUESTED,
  SET_DRAWER_OPENED,
  SET_MOBILE_MODE,
  TOGGLE_CU_NOTIFICATIONS,
  TOGGLE_IS_NAVIGATION_SHOWN,
  UNPIN_BUILDING,
} from '../actionConstants';

import {
  getIsMobileScreen,
  loadIsLeftMenuOpened,
  loadPinnedBuildings,
  loadServiceData,
  loadTimezonesData,
  loadToken,
  loadUser,
  saveLeftMenuState,
  savePinnedBuildings,
} from '../utils';

const defaultState = {
  token: loadToken(),
  currentUser: loadUser(),
  isNavigationShown: false,
  isCUNotificationsShown: false,
  pmcs: [],
  countries: [],
  states: [],
  service: loadServiceData(),
  timezones: loadTimezonesData(),
  serviceRequestCategories: [],
  loading: [],
  title: '',
  isLiveMode: false,
  deliveryTypes: null,
  isDrawerOpen: !getIsMobileScreen() && loadIsLeftMenuOpened(),
  isMobileScreen: getIsMobileScreen(),
  pinnedBuildings: loadPinnedBuildings(),
  requestControllers: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case LOGOUT:
      return {
        ...state,
        token: null,
        currentUser: null,
        isDrawerOpen: !getIsMobileScreen(),
        isMobileScreen: getIsMobileScreen(),
        pinnedBuildings: [],
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isDrawerOpen: !getIsMobileScreen(),
        isMobileScreen: getIsMobileScreen(),
        token: action.token,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        token: null,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.res.data,
      };
    case COUNTRIES_LOADED:
      return {
        ...state,
        countries: action.error ? null : action.payload.data,
      };
    case GET_STATES_BY_COUNTRY_ID_SUCCESS:
      return {
        ...state,
        states: action.res.data,
      };
    case PMC_LIST_REQUESTED: {
      const pmcs =
        get(action, 'payload.data.data', null) ||
        get(action, 'payload.data', []);
      return {
        ...state,
        pmcs: action.error ? null : pmcs,
      };
    }
    case GET_SERVICE_DATA_SUCCESS:
      return {
        ...state,
        service: action.res ? action.res.data : null,
      };
    case GET_TIMEZONES_DATA_SUCCESS:
      return {
        ...state,
        timezones: action?.res ? action?.res?.data : null,
      };
    case TOGGLE_IS_NAVIGATION_SHOWN:
      return {
        ...state,
        isNavigationShown: action.isNavigationShown,
      };
    case TOGGLE_CU_NOTIFICATIONS:
      return {
        ...state,
        isCUNotificationsShown: !state.isCUNotificationsShown,
      };
    case SERVICE_REQUEST_CATEGORIES_REQUESTED:
      return {
        ...state,
        serviceRequestCategories: action.error ? null : action.payload.data,
      };
    case ASYNC_START: {
      if (action.withoutLoading) {
        return state;
      }
      const loading = state.loading.concat(action.id);
      return {
        ...state,
        loading,
      };
    }
    case ASYNC_END: {
      return {
        ...state,
        loading: state.loading.filter((item) => item !== action.id),
      };
    }

    case GET_DELIVERY_TYPES_SUCCESS: {
      return {
        ...state,
        deliveryTypes: action?.res?.data,
      };
    }
    case SET_DRAWER_OPENED: {
      saveLeftMenuState(action.isDrawerOpen);
      return {
        ...state,
        isDrawerOpen: action.isDrawerOpen,
      };
    }
    case SET_MOBILE_MODE: {
      return {
        ...state,
        isMobileScreen: action.isMobileScreen,
      };
    }
    case PIN_BUILDING: {
      const { buildingId, buildingName } = action;
      const pinnedBuildings = [
        ...state.pinnedBuildings,
        { buildingId, buildingName },
      ];
      savePinnedBuildings(pinnedBuildings);
      return {
        ...state,
        pinnedBuildings,
      };
    }
    case UNPIN_BUILDING: {
      const { buildingId } = action;
      const pinnedBuildings = [...state.pinnedBuildings].filter(
        (building) => building.buildingId !== buildingId,
      );
      savePinnedBuildings(pinnedBuildings);
      return {
        ...state,
        pinnedBuildings,
      };
    }

    case ADD_ABORT_CONTROLLER: {
      const { controller } = action;
      return {
        ...state,
        requestControllers: [...state.requestControllers, controller],
      };
    }
    case CLEAR_ABORT_CONTROLLER: {
      return {
        ...state,
        requestControllers: [],
      };
    }

    default:
      return state;
  }
};
